import SellerDeliveryInformationForm from './SellerDeliveryInformationForm'

export default SellerDeliveryInformationForm
